// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3Sls2","subheader":"ReorderModal_subheader__3jTFb","listWrap":"ReorderModal_listWrap__1g_xT"};